function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSurveyRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M26 5h-2v2h2v21H6V7h2V5H6c-1.1 0-2 .9-2 2v21c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10h12V4c0-1.1-.9-2-2-2h-8c-1.1 0-2 .9-2 2v6zm2-6h8v4h-8V4zM22 14H10v2h12v-2zM22 18H10v2h12v-2zM22 22H10v2h12v-2z",
    fill: props.color
  }));
}

export default SvgIconSurveyRexOutline;